import React, { memo } from 'react';
// import _ from 'lodash';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

import TableDetails from './TableDetails';

const styles = StyleSheet.create({
  display__flex: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
  },
  main__heading: {
    fontSize: 10,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  mini__heading: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  mini__heading__inner: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  container__main: {
    marginTop: 10,
  },
});

const Table = ({ data }) => {
  const {
    jobs = [],
    currencySymbol = '$',
    invoiceTemplate = [],
    addCommasToNumber,
  } = data || '';

  // making invoice according to invoice template
  const jobsInfo =
    invoiceTemplate.find((temp) => temp.title?.toLowerCase() === 'jobs')
      ?.options || '';
  const jobTotals =
    invoiceTemplate.find((temp) => temp.title?.toLowerCase() === 'job totals')
      ?.options || '';

  const workInProgressNotes =
    invoiceTemplate.find((temp) => temp['workInProgressNotes'] === true) ||
    false;

  const showJobs = Object.values(jobsInfo ?? {})?.some((c) => c);

  return showJobs ? (
    <>
      {jobs?.map((job, i) => {
        return (
          <View style={styles.container__main}>
            <View style={styles.display__flex} key={i++}>
              <View>
                <Text style={styles.main__heading}>
                  {i + 1} of {jobs?.length}
                  {job?.title ? '. ' + job.title : ''}
                </Text>
              </View>
              <View>
                <Text style={styles.mini__heading}>
                  Reference:
                  <Text style={styles.mini__heading__inner}>
                    {' '}
                    {job?.ro_concerns_recommendation?.issueType ===
                    'customerConcern'
                      ? 'Customer Concern'
                      : 'Tech Recommendation'}
                  </Text>
                </Text>
              </View>
            </View>
            <View>
              <TableDetails
                currencySymbol={currencySymbol}
                job={job}
                jobsInfo={jobsInfo}
                jobTotals={jobTotals}
                addCommasToNumber={addCommasToNumber}
                workInProgressNotes={workInProgressNotes}
              />
            </View>
          </View>
        );
      })}
    </>
  ) : (
    <View />
  );
};
export default memo(Table);
